(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("@noahsaso/cosmodal", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["@noahsaso/cosmodal"] = factory(require("react"), require("react-dom"));
	else
		root["@noahsaso/cosmodal"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 